/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Actions/EndpointsEditorActionsHub" />
import { ServiceEndpointType, ServiceEndpoint, OAuthConfiguration } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { EndpointSaveStatus } from "DistributedTaskUI/ServiceEndpoints/Editor/Components/EndpointsEditorPanelInterfaces";

export class EndpointsEditorActionsHub extends ActionsHubBase {
    public static getKey(): string {
        return "endpoints-editor-actions";
    }

    public initialize(instanceId?: string): void {
        this._setEndpointDraftMode = new Action<boolean>();
        this._setEndpointCreationMode = new Action<string>();
        this._setAuthenticationScheme = new Action<string>();
        this._setServiceEndpointType = new Action<ServiceEndpointType>();
        this._setServiceEndpoint = new Action<ServiceEndpoint>();
        this._setOAuthConfigurations = new Action<OAuthConfiguration[]>();
        this._updateOpenToAllPipelinesFlag = new Action<boolean>();
        this._initializeStateEndpoint = new Action<ServiceEndpoint>();
        this._updateSaveProgress = new Action<EndpointSaveStatus>();
        this._setErrorMessage = new Action<string>();
        this._setErrorDetails = new Action<ErrorDetails>();
        this._removeEndpointCreationMode = new Action<void>();
    }

    public get removeEndpointCreationMode(): Action<void> {
        return this._removeEndpointCreationMode;
    }

    public get setEndpointDraftMode(): Action<boolean> {
        return this._setEndpointDraftMode;
    }

    public get setEndpointCreationMode(): Action<string> {
        return this._setEndpointCreationMode;
    }

    public get setAuthenticationScheme(): Action<string> {
        return this._setAuthenticationScheme;
    }

    public get setServiceEndpointType(): Action<ServiceEndpointType> {
        return this._setServiceEndpointType;
    }

    public get setServiceEndpoint(): Action<ServiceEndpoint> {
        return this._setServiceEndpoint;
    }

    public get setOAuthConfigurations(): Action<OAuthConfiguration[]> {
        return this._setOAuthConfigurations;
    }

    public get updateOpenToAllPipelinesFlag(): Action<boolean> {
        return this._updateOpenToAllPipelinesFlag;
    }

    public get initializeStateEndpoint(): Action<ServiceEndpoint> {
        return this._initializeStateEndpoint;
    }

    public get updateSaveProgress(): Action<EndpointSaveStatus> {
        return this._updateSaveProgress;
    }

    public get setErrorMessage(): Action<string> {
        return this._setErrorMessage;
    }

    public get setErrorDetails(): Action<ErrorDetails> {
        return this._setErrorDetails;
    }

    private _setEndpointDraftMode: Action<boolean>;
    private _setEndpointCreationMode: Action<string>;
    private _setAuthenticationScheme: Action<string>;
    private _setServiceEndpointType: Action<ServiceEndpointType>;
    private _setServiceEndpoint: Action<ServiceEndpoint>;
    private _setOAuthConfigurations: Action<OAuthConfiguration[]>;
    private _updateOpenToAllPipelinesFlag: Action<boolean>;
    private _initializeStateEndpoint: Action<ServiceEndpoint>;
    private _updateSaveProgress: Action<EndpointSaveStatus>;
    private _setErrorMessage: Action<string>;
    private _setErrorDetails: Action<ErrorDetails>;
    private _removeEndpointCreationMode: Action<void>;
}

export interface ErrorDetails {
    errorMessage?: string;
    isError?: boolean;
    activityId?: string;
}